import { render, staticRenderFns } from "./GoalMentorsSuggestionsList.vue?vue&type=template&id=3d704c5e"
import script from "./GoalMentorsSuggestionsList.vue?vue&type=script&lang=js"
export * from "./GoalMentorsSuggestionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports